module.exports = __webpack_public_path__ + "static/img/item_shop_car.c65ac36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item_shop_car.png
// module id = cmU+
// module chunks = 1